// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;90</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;Lord, you have been our refuge&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;from one generation to another.<br> </p> </div></div>";
// Exports
module.exports = code;